import { Play, Plus, Info } from "lucide-react";

export const Hero = ({ movie, onPlay, onMore, onAddList }) => {
  if (!movie) return null;
  const bg = movie.backdrop_url || movie.poster_url;
  return (
    <section
      className="relative w-full h-[92vh] min-h-[640px] overflow-hidden"
      data-testid="hero-banner"
    >
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{ backgroundImage: `url(${bg})` }}
      />
      <div className="absolute inset-0 hero-fade" />
      <div className="absolute inset-0 hero-side-fade" />

      <div className="relative h-full max-w-[1500px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-24 md:pb-32 fade-up">
        <span className="text-xs uppercase tracking-[0.3em] text-[#D9381E] mb-4" data-testid="hero-eyebrow">
          In the Spotlight
        </span>
        <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter leading-none text-white max-w-3xl"
            data-testid="hero-title">
          {movie.title}
        </h1>
        <div className="flex items-center gap-4 mt-5 text-xs uppercase tracking-[0.2em] text-[#8A8A8A]">
          <span>{movie.year}</span>
          <span className="w-1 h-1 bg-[#444] rounded-full" />
          <span>{movie.rating}</span>
          {movie.duration_minutes ? (
            <>
              <span className="w-1 h-1 bg-[#444] rounded-full" />
              <span>{movie.duration_minutes} min</span>
            </>
          ) : null}
          {movie.genres?.length ? (
            <>
              <span className="w-1 h-1 bg-[#444] rounded-full" />
              <span>{movie.genres.slice(0, 3).join(" · ")}</span>
            </>
          ) : null}
        </div>
        <p className="mt-6 text-base md:text-lg text-[#C8C8C8] max-w-2xl leading-relaxed line-clamp-3">
          {movie.description}
        </p>

        <div className="flex items-center gap-3 mt-8">
          <button
            onClick={() => onPlay?.(movie)}
            className="flex items-center gap-3 bg-[#D9381E] hover:bg-[#ED4B32] text-white px-7 py-3 transition-colors duration-300"
            data-testid="hero-play-button"
          >
            <Play size={18} fill="white" strokeWidth={0} />
            <span className="text-sm uppercase tracking-[0.2em] font-medium">Watch</span>
          </button>
          <button
            onClick={() => onMore?.(movie)}
            className="flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white px-7 py-3 transition-colors duration-300 backdrop-blur-md border border-white/10"
            data-testid="hero-more-info-button"
          >
            <Info size={18} strokeWidth={1.5} />
            <span className="text-sm uppercase tracking-[0.2em] font-medium">Details</span>
          </button>
          <button
            onClick={() => onAddList?.(movie)}
            className="hidden sm:flex items-center gap-3 text-white/70 hover:text-white px-3 py-3 transition-colors duration-300"
            data-testid="hero-add-list-button"
          >
            <Plus size={18} strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-[0.2em]">Save</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
